type Game5Map = {
  intro: string[]
  items: Array<{
    id: string
    label: string
    img: string
    falseAnswers: string[]
    correctMsg: string
  }>
  clipPaths: { [key: number]: string }
  errorMsgs: string[]
}

export const Game5Map: Game5Map = {
  intro: ['Uhádneš co je na obrázku? Další díl obrázku si můžes odkrýt kliknutím.'],
  items: [
    {
      id: 'acorn',
      label: 'ŽALUDY z dubu',
      img: require('../assets/game5/01_zaludy_d-min.jpg').default,
      falseAnswers: ['HLOŽINKY z keře hlohu', 'BUKVICE z buku', 'KAŠTAN z jírovce maďalu'],
      correctMsg: 'Trefa! Víš, které lesní zvíře si na žaludech nejvíc pochutná? Správně, je to prase divoké.',
    },
    {
      id: 'rowanberry',
      label: 'JEŘABINY z jeřábu',
      img: require('../assets/game5/02_jerabiny_d-min.jpg').default,
      falseAnswers: ['MALINY z keře ostružiníku maliníku', 'ŠÍPEK z keře růže šípkové', 'HLOŽINKY z keře hlohu'],
      correctMsg: 'Trefa do černého! Pokud jeřabiny nesezobou ptáci, vyrobím si z nich kompot.',
    },
    {
      id: 'beech',
      label: 'BUKVICE z buku',
      img: require('../assets/game5/04_bukvice-min.jpg').default,
      falseAnswers: ['ŽALUDY z dubu', 'OŘÍŠEK z lísky obecné', 'KAŠTAN z jírovce maďalu'],
      correctMsg: 'Výborně! Víš, které lesní zvíře si na bukvicích nejvíc pochutná? Ano, je to prase divoké.',
    },
    {
      id: 'blueberry',
      label: 'BORŮVKY z rostliny brusnice borůvky',
      img: require('../assets/game5/06_boruvky_d-min.jpg').default,
      falseAnswers: ['HLOŽINKY z keře hlohu', 'OSTRUŽINY z keře ostružiníku', 'ŠÍPEK z keře růže šípkové'],
      correctMsg: 'Správně! Víš, že borůvky jsou léčivé? Zkus na internetu najít, čím jsou prospěšné.',
    },
    {
      id: 'raspberry',
      label: 'MALINY z keře ostružiníku maliníku',
      img: require('../assets/game5/03_maliny_d-min.jpg').default,
      falseAnswers: ['HLOŽINKY z keře hlohu', 'JAHODA z jahodníku obecného', 'BORŮVKY z rostliny brusnice borůvky'],
      correctMsg: 'Správně! Také si ze sušených maliníkových listů děláš v zimě výborný čaj jako já?',
    },
    {
      id: 'hawthorn',
      label: 'HLOŽINKY z keře hlohu',
      img: require('../assets/game5/05_hloh_d-min.jpg').default,
      falseAnswers: ['MALINY z keře ostružiníku maliníku', 'ŠÍPEK z keře růže šípkové', 'JEŘABINY z jeřábu'],
      correctMsg: 'Trefa! Víš, že plody a květy hlohu jsou léčivé? Zkus na internetu najít, čím jsou prospěšné.',
    },
    {
      id: 'rosehip',
      label: 'ŠÍPEK z keře růže šípkové',
      img: require('../assets/game5/07_sipky_d-min.jpg').default,
      falseAnswers: ['MALINY z keře ostružiníku maliníku', 'HLOŽINKY z keře hlohu', 'JEŘABINY z jeřábu'],
      correctMsg:
        'Jasan! Inu, šípkový čaj nemusím nikomu představovat. A kance radši s šípkovou omáčkou než se zelím, že? Šípky jsou zdravé, mají vysoký obsah vitamínu C.',
    },
  ],
  clipPaths: {
    // separate areas
    // 0: 'polygon(0% 0%, 33% 0%, 33% 50%, 0% 50%)',
    // 0: 'polygon(50% 0%, 33% 50%, 33% 100%, 0% 100%)',
    // 1: 'polygon(0% 0%, 0% 33%, 50% 33%, 50% 0%)',
    // 1: 'polygon(66% 0%, 100% 0%, 100% 100%, 66% 100%)',
    // 2: 'polygon(33% 0%, 100% 0%, 100% 100%, 66% 100%, 66% 50%, 33% 50%)',
    // 3: 'polygon(33% 0%, 100% 0%, 100% 100%, 33% 100%)',
    // 4: 'polygon(33% 0%, 100% 0%, 100% 100%, 33% 100%, 33% 50%, 0% 50%, 0% 0%)',
    // whole areas
    // 0: 'polygon(66% 0%, 100% 0%, 100% 50%, 66% 50%)',
    // 1: 'polygon(66% 0%, 100% 0%, 100% 100%, 66% 100%)',
    // 2: 'polygon(33% 0%, 100% 0%, 100% 100%, 66% 100%, 66% 50%, 33% 50%)',
    // 3: 'polygon(33% 0%, 100% 0%, 100% 100%, 33% 100%)',
    // 4: 'polygon(33% 0%, 100% 0%, 100% 100%, 33% 100%, 33% 50%, 0% 50%, 0% 0%)',
  },
  errorMsgs: ['Kdepak.', 'Těsně vedle.', 'Mordyjé, netrefil se.', 'Vedle jak ta jedle.', 'Zkus to znovu.'],
}
